import React, { useCallback } from 'react';
import { Table } from 'react-bootstrap';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

import DraggableRow from './DraggableRow';

import '../styles.scss';

export default ({ headers, classTable, rows, onChangeRows }) => {

  const onDragEnd = useCallback((result) => {
    const { destination, source, reason } = result;

    // Not a thing to do...
    if (!destination || !source || reason === 'CANCEL') {
      return;
    }

    if (destination.droppableId === source.droppableId && destination.index === source.index) {
      return;
    }
    if (!isNaN(+source.index) && !isNaN(+destination.index)) {
      onChangeRows(source.index, destination.index);
    }
  }, [onChangeRows]);

  const processedHeaders = headers.map((header, index) => {
    const thCell = <>
      {header.print ? header.print(header.content) : header.content}
    </>;

    return <th
      key={index}
      style={header.style ? { ...header.style } : {}}
      className={
        (header.class ? header.class : '') +
        (header.isColumnFixedY ? ' OGCY-fixed-horizontal' : '') +
        // (isPinnedStyle ? ' OGCY-fixed-vertical' : '') +
        (header.rightShadow ? ' nvd-custom-table-tr-td-right-shadow' : '')
        // (header.rightShadow ? ' nvd-custom-table-tr-td-right-shadow-corn' : '')
      }
    >
      <span>{thCell}</span>
    </th>;
  });

  return (
    <Table className="nvd-custom-table">
      <thead>
      <tr className="nvd-custom-table-thead-tr-head">
        {processedHeaders}
      </tr>
      </thead>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="dnd-table">
          {(provided, snapshot) => (
            <tbody {...provided.droppableProps} ref={provided.innerRef}>
            {rows.map((row, index) => (
              <DraggableRow data={row} index={index} key={index} draggableId={row.id} headers={headers} />
            ))}
            {provided.placeholder}
            </tbody>
          )}
        </Droppable>
      </DragDropContext>
    </Table>
  );
};
